import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { id: String }

  purge() {
    this.element.remove()
  }

  copyReference() {
    navigator.clipboard.writeText(`![image_${this.idValue}]`)
  }
}
